<template>
    <div id="forgot-password-page">
        <div class="branding-hero shadow-lg"><img class="background" src="/goobank_assets/assets/login-background-default.jpg">
            <div class="logo d-flex flex-column align-items-center justify-content-center pt-5 pb-3 pl-3 pr-3"><img class="square-icon mb-1" src="/goobank_assets/assets/square-icon@2x.png"><img class="text-branding mt-2" src="/goobank_assets/assets/text-branding@2x.png"></div>
            <div class="title mt-3 pt-2 pb-2 pl-4 pr-4">
                <h2 class="text-light font-weight-normal">ลืมรหัสผ่าน</h2>
            </div>
        </div>
        <div v-show="stepNumber == 1" class="content p-4 pt-5">
            <div class="form-group form-goobank">
                <input class="form-control is-valid" name="telephone" type="telephone" v-model="telephone">
                <label for="username">Username หรือ เบอร์โทรที่ใช้สมัคร</label>
                <div class="invalid-feedback">กรุณากรอกข้อมูลให้ครบถ้วน</div>
            </div>

            <a class="btn btn-primary btn-block btn-lg mb-3" href="#" @click="sendForgotPassword()" >ขอรหัสผ่านใหม่</a>
            <a class="btn btn-light btn-block btn-lg mb-3" href="/">ย้อนกลับ</a>
        </div>
        <div v-show="stepNumber == 2">
            <div class="container mt-4 pr-4 pl-4">
                <div class="card shadow">
                    <div class="card-body">
                        <div class="img-container text-center p-2"><img class="w-100" src="/goobank_assets/assets/icons/img-register-complete.png" /></div>
                        <div class="p-4 text-center">
                            <h3 class="font-weight-normal">ส่งเรื่องให้เจ้าหน้าที่แล้ว</h3>
                            <p>เจ้าหน้าที่จะติดต่อและช่วยเหลือท่านตามเบอร์ที่แจ้งมาโดยเร็วที่สุด</p>
                        </div>
                        <div class="mt-2 pt-2 pb-4 pl-3 pr-3 mb-4">
                            <a class="btn btn-primary btn-block btn-lg" href="#" @click="backAndClearForm()">กลับไปหน้าลืมรหัสผ่านใหม่</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import Loading from 'vue-loading-overlay';

    Vue.use(VeeValidate);
    Vue.use(Loading);

    export default {
        components: {
            Loading,
        },
        data: function () {
            return {
                stepNumber: 1,
                telephone: ""
            }
        },
        methods: {
            backAndClearForm() {
                this.stepNumber = 1;
                this.telephone = "";
            },
            sendForgotPassword() {
                const vm = this;
                axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content");

                var formData = new FormData();
                formData.append('telephone', vm.telephone);
                
                axios.post('/api/forgot-password/send-forgot-password',
                    formData
                ).then(({ data }) => {
                    if (data != null) {
                        if (!data.success) {
                            // alert("Something Error!");
                            if (data.message) {
                                alert(data.message);
                            }
                        } else {
                            // Go to completed page.
                            vm.stepNumber = 2;
                        }
                    }
                }).catch(err => {

                }).then(() => {
                    this.hideLoading();
                });
                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #forgot-password-page .el-avatar-loading, #forgot-password-page .el-avatar-loading img {
        width: 100%;
    }
</style>
